// extracted by mini-css-extract-plugin
export default {"logoContainer":"confirmation_page_logoContainer__c4MR6","logo":"confirmation_page_logo__9rNmO"};